import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router'

Vue.use(Router)

// 重写路由的push方法
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) { 
//   // return routerPush.call(this, location).catch(error => error)
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return routerPush.call(this, location).catch(err => err)
// }

// 定义路由
const routes=[
  {
    path: '/',
    component: ()=> import("../views/layout/index.vue"),
    redirect: '/Dashboard',
    children: [{
      path: '/Dashboard',
      component: () => import('../views/dashboard/index.vue'),
      name: 'Dashboard',
      meta: {
        title: '数据统计',
        icon: 'UserList',
        affix: true
      }
    }]
  },
  {
    path: '/redirect',
    component: ()=> import("../views/layout/index.vue"),
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/views/redirect/index.vue')
    }]
  },
  {
    path: '/login',
    name: 'login',
    component: ()=>import("../views/login/login.vue"),
  },
  {
    path: '*',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
]

const createRouter = ()=> new VueRouter({
  routes,
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router;